import React, {useEffect, useState, useRef} from 'react';
import {
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonIcon,
    IonLabel, IonTabs, IonPage, IonModal, IonContent, useIonAlert
} from '@ionic/react';
import {Route, Redirect,useLocation } from 'react-router-dom';


import HomeDesktopPage from './HomeDesktopPage';
import JobPortalMobilePage from './JobPortalMobilePage';
import MatrimonialMobilePage from './MatrimonialMobilePage';
import NewsletterMobilePage from './NewsletterMobilePage';
import {
    briefcaseOutline,
    briefcase, calendarOutline, calendar, cashOutline, cash,
    clipboardOutline,
    clipboard,
    ellipsisHorizontal,
    heartOutline,
    heart,
    homeOutline,
    home, newspaperOutline, newspaper
} from "ionicons/icons";
import HeaderAfterLoginComponent from "../components/HeaderAfterLoginComponent";
import JobPortalDesktopPage from "./JobPortalDesktopPage";
import HomeMobilePage from "./HomeMobilePage";
import MatrimonialDesktopPage from "./MatrimonialDesktopPage";
import NewsletterDesktopPage from "./NewsletterDesktopPage";
import {useHistory} from "react-router-dom";
import EventsDesktopPage from "./EventsDesktopPage";
import EventsMobilePage from "./EventsMobilePage";
import ContributeDesktopPage from "./ContributeDesktopPage";
import ContributeMobilePage from "./ContributeMobilePage";
import MembershipDesktopPage from "./MembershipDesktopPage";
import MembershipMobilePage from "./MembershipMobilePage";
import AboutUsPage from "./AboutUsPage";
import CfoworldPage from "./CfoworldPage";
import FicafPage from "./FicafPage";
import CommitteesPage from "./CommitteesPage";
import ContactUsPage from "./ContactUsPage";
import BecomeMemberPopup from "../components/BecomeMemberPopup";
import {actionToGetActiveUserMembershipById, actionToLogoutUserSession} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";
import PolicyPage from "./PolicyPage";
import DeactivateAccountPage from "./DeactivateAccountPage";
import LeftSideMenuComponent from "../components/LeftSideMenuComponent";
import NotificationListener from "../hooks/NotificationListener";
import NotificationSheet from "../components/NotificationSheet";
import AssignmentMobileDashboardPage from "../components/AssignmentMobileDashboardPage";
import AssignmentDesktopDashboard from "../components/AssignmentDesktopDashboard";
import {useBannerManagerNative} from "../hooks/useBannerManagerNative";
import FcmTokenRegistrarNative from "../components/FcmTokenRegistrarNative";
import {setupDownloadNotifications} from "../lib/downloadHelper";
import {registerDeepLinks} from "../lib/deeplinks";


setupDownloadNotifications();
// constants you can tune
const HIDE_AFTER_SCROLLING_DOWN = 24;  // px to hide
const SHOW_AFTER_SCROLLING_UP   = 80;  // px to show
const TOP_SAFE_ZONE             = 8;   // always show near top


const DashboardPage = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1000);
    const [currentPath,setCurrentPath] = useState('/dashboard/home')
    const [showMoreSheet, setShowMoreSheet] = useState(false);
    const history = useHistory();
    const menuRef = useRef(null);
    const bottomTabSectionRef = useRef(null);
    const {pathname} = useLocation();
    const {currentMemberMemberShipDetail} = useStore();
    const {loading,memberShipDetail} = currentMemberMemberShipDetail;
    const {menuOpen, setMenuOpen} = useStore();
    const [presentAlert] = useIonAlert();

    //////// FOR SCROLL HIDE ////////////
    const lastScrollTop = useRef(0);
    const [hideHeader, setHideHeader] = useState(false);
    const anchorRef = useRef(0);           // reference y for next decision
    const timeoutRef = useRef(null); // debounce holder
    const tickingRef = useRef(false);

    useBannerManagerNative();

    useEffect(() => {
        registerDeepLinks(history);
    }, []);

    // optional: avoid redundant state updates
    const setHiddenSafely = (next) => {
        setHideHeader(prev => (prev !== next ? next : prev));
    };

    const handleScroll = (event) => {
        const raw = event.detail?.scrollTop ?? 0;
        const y = raw < 0 ? 0 : raw;

        // --- small debounce so we don't react to touch jitter
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(() => {
            // --- throttle decisions to one per frame
            if (tickingRef.current) return;
            tickingRef.current = true;

            requestAnimationFrame(() => {
                // Always show when very close to top (nice UX)
                if (y <= TOP_SAFE_ZONE) {
                    setHiddenSafely(false);
                    anchorRef.current = y;
                    lastScrollTop.current = y;
                    tickingRef.current = false;
                    return;
                }

                if (!hideHeader) {
                    // user scrolling DOWN enough? -> hide
                    if (y - anchorRef.current > HIDE_AFTER_SCROLLING_DOWN) {
                        setHiddenSafely(true);
                        anchorRef.current = y; // reset anchor at action point
                    }
                } else {
                    // user scrolling UP enough? -> show
                    if (anchorRef.current - y > SHOW_AFTER_SCROLLING_UP) {
                        setHiddenSafely(false);
                        anchorRef.current = y; // reset anchor at action point
                    }
                }

                lastScrollTop.current = y;
                tickingRef.current = false;
            });
        }, 60); // debounce window in ms (40–80 feels good)
    };

    useEffect(() => {
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);

    //////// FOR SCROLL HIDE ////////////

    useEffect(() => {
        setCurrentPath(pathname);
    }, [pathname]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1000);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const gotToPage = (path,type)=>{
        setCurrentPath(type)
        history.replace(path);
        setShowMoreSheet(false);
        setHideHeader(false);
        closeMenu();
    }

    const callFunctionToSetCurrentPath = (path) =>{
        setCurrentPath(path);
        setShowMoreSheet(false);
        setHideHeader(false);
        closeMenu();
    }

    const closeMenu = () => {
        const menu = menuRef.current;
        if (menu) {
            menu.close()
        }
    };

    const callFunctionToOpenShowMoreSheet = () => {
        const tabBarEl = document.querySelector('.main-tab-bar');
        if (tabBarEl) {
            const tabHeight = tabBarEl.getBoundingClientRect().height;
            document.documentElement.style.setProperty('--tab-bar-height', `${tabHeight}px`);
        }
        setShowMoreSheet(!showMoreSheet);
    };

    useEffect(() => {
        actionToGetActiveUserMembershipById();
    }, []);

    const callFunctionToLogoutUser = ()=>{
        presentAlert({
            header: 'Confirm Logout',
            cssClass:"confirm_alert_custom",
            message: 'Are you sure you want to log out?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                },
                {
                    text: 'Yes',
                    handler: () => {
                        actionToLogoutUserSession();
                    },
                },
            ],
        });
    }

    // somewhere in your parent (e.g. DashboardLayout.jsx)
    const renderHeaderPage = (panelSubHeader = null) => (
        <HeaderAfterLoginComponent
            menuRef={menuRef}
            currentPath={currentPath}
            callFunctionToLogoutUser={callFunctionToLogoutUser}
            menuOpen={menuOpen}
            setMenuOpen={setMenuOpen}
            isMobile={isMobile}
            panelSubHeader={panelSubHeader}
            setCurrentPath={setCurrentPath}
            menuId="main-menu"
            hideHeader={hideHeader}
        />
    );

    useEffect(() => {
        const el = menuRef.current;
        if (!el) return;

        const onOpen  = () => {
            setMenuOpen(true);
        };
        const onClose = () => {
            setMenuOpen(false);
        };

        el.addEventListener('ionDidOpen', onOpen);
        el.addEventListener('ionDidClose', onClose);
        return () => {
            el.removeEventListener('ionDidOpen', onOpen);
            el.removeEventListener('ionDidClose', onClose);
        };
    }, [menuRef]);



    return (
        <IonTabs>
            <IonRouterOutlet>
                <Route path="/dashboard/" render={() => (
                    <IonPage>
                        {/*///////// LEFT SIDE MOBILE MENU /////////*/}
                        <LeftSideMenuComponent
                            menuOpen={menuOpen}
                            setMenuOpen={setMenuOpen}
                            isMobile={isMobile}
                            setCurrentPath={setCurrentPath}
                            menuRef={menuRef}
                            callFunctionToLogoutUser={callFunctionToLogoutUser}
                            menuId="main-menu"
                            pageId="main-menu-content"/>
                        {/*///////// LEFT SIDE MOBILE MENU /////////*/}
                        <IonRouterOutlet id="main-menu-content">
                            <Route exact path="/dashboard/home" render={()=>(
                                <>
                                    {(isMobile) ?
                                        <HomeMobilePage renderHeaderPage={renderHeaderPage}/>
                                        :
                                        <HomeDesktopPage renderHeaderPage={renderHeaderPage}/>
                                    }
                                    {(!loading && !memberShipDetail?.id) ?
                                        <BecomeMemberPopup/>:''
                                    }
                                </>
                            )} />

                            <Route exact path="/dashboard/home/:id" render={()=>(
                                <>
                                    {(isMobile) ?
                                        <HomeMobilePage renderHeaderPage={renderHeaderPage}/>
                                        :
                                        <HomeDesktopPage renderHeaderPage={renderHeaderPage}/>
                                    }
                                    {(!loading && !memberShipDetail?.id) ?
                                        <BecomeMemberPopup/>:''
                                    }
                                </>
                            )} />
                            <Route exact path="/dashboard/job-portal" render={()=>(
                                <>
                                    {(isMobile) ?
                                        <JobPortalMobilePage handleScroll={handleScroll} renderHeaderPage={renderHeaderPage}/>
                                        :
                                        <JobPortalDesktopPage isMobile={isMobile} renderHeaderPage={renderHeaderPage}/>
                                    }
                                </>
                            )} />

                            <Route exact path="/dashboard/job-portal/:id" render={()=>(
                                <>
                                    {(isMobile) ?
                                        <JobPortalMobilePage isMobile={isMobile} handleScroll={handleScroll} renderHeaderPage={renderHeaderPage}/>
                                        :
                                        <JobPortalDesktopPage isMobile={isMobile} renderHeaderPage={renderHeaderPage}/>
                                    }
                                </>
                            )} />

                            <Route exact path="/dashboard/matrimonial" render={()=>(
                                <>
                                    {(isMobile) ?
                                        <MatrimonialMobilePage isMobile={isMobile} handleScroll={handleScroll} renderHeaderPage={renderHeaderPage}/>
                                        :
                                        <MatrimonialDesktopPage isMobile={isMobile} renderHeaderPage={renderHeaderPage}/>
                                    }
                                </>
                            )} />

                            <Route exact path="/dashboard/assignments" render={()=>(
                                <>
                                    {(isMobile) ?
                                        <AssignmentMobileDashboardPage isMobile={isMobile} renderHeaderPage={renderHeaderPage}/>
                                        :
                                        <AssignmentDesktopDashboard  isMobile={isMobile} renderHeaderPage={renderHeaderPage}/>
                                    }
                                </>
                            )} />

                            <Route exact path="/dashboard/assignments/:id" render={()=>(
                                <>
                                    {(isMobile) ?
                                        <AssignmentMobileDashboardPage isMobile={isMobile} renderHeaderPage={renderHeaderPage}/>
                                        :
                                        <AssignmentDesktopDashboard  isMobile={isMobile} renderHeaderPage={renderHeaderPage}/>
                                    }
                                </>
                            )} />

                            <Route exact path="/dashboard/newsletter" render={()=>(
                                <>
                                    {(isMobile) ?
                                        <NewsletterMobilePage handleScroll={handleScroll} renderHeaderPage={renderHeaderPage}/>
                                        :
                                        <NewsletterDesktopPage renderHeaderPage={renderHeaderPage}/>
                                    }
                                </>
                            )} />

                            <Route exact path="/dashboard/events" render={()=>(
                                <>
                                    {(isMobile) ?
                                        <EventsMobilePage handleScroll={handleScroll} renderHeaderPage={renderHeaderPage}/>
                                        :
                                        <EventsDesktopPage renderHeaderPage={renderHeaderPage}/>
                                    }
                                </>
                            )} />

                            <Route exact path="/dashboard/events/:id" render={()=>(
                                <>
                                    {(isMobile) ?
                                        <EventsMobilePage handleScroll={handleScroll} renderHeaderPage={renderHeaderPage}/>
                                        :
                                        <EventsDesktopPage renderHeaderPage={renderHeaderPage}/>
                                    }
                                </>
                            )} />

                            <Route exact path="/dashboard/contribute" render={()=>(
                                <>
                                    {(isMobile) ?
                                        <ContributeMobilePage handleScroll={handleScroll} renderHeaderPage={renderHeaderPage}/>
                                        :
                                        <ContributeDesktopPage renderHeaderPage={renderHeaderPage}/>
                                    }
                                </>
                            )} />

                            <Route exact path="/dashboard/membership" render={()=>(
                                <>
                                    {(isMobile) ?
                                        <MembershipMobilePage handleScroll={handleScroll} renderHeaderPage={renderHeaderPage}/>
                                        :
                                        <MembershipDesktopPage renderHeaderPage={renderHeaderPage}/>
                                    }
                                </>
                            )} />

                            <Route exact path="/dashboard/about-us" render={()=>(<AboutUsPage renderHeaderPage={renderHeaderPage}/>)} />
                            <Route exact path="/dashboard/cfoworld" render={()=>(<CfoworldPage renderHeaderPage={renderHeaderPage}/>)} />
                            <Route exact path="/dashboard/ficaf" render={()=>(<FicafPage renderHeaderPage={renderHeaderPage}/>)} />
                            <Route exact path="/dashboard/committees" render={()=>(<CommitteesPage renderHeaderPage={renderHeaderPage}/>)} />
                            <Route exact path="/dashboard/contact-us" render={()=>(<ContactUsPage renderHeaderPage={renderHeaderPage}/>)} />
                            <Route exact path="/dashboard/policy" render={()=>(<PolicyPage renderHeaderPage={renderHeaderPage}/>)} />
                            <Route exact path="/dashboard/deactivate" render={()=>(<DeactivateAccountPage renderHeaderPage={renderHeaderPage}/>)} />
                            <Redirect exact from="/dashboard" to="/dashboard/home" />

                        </IonRouterOutlet>
                        <NotificationListener/>
                        <NotificationSheet/>
                    </IonPage>
                )} />
            </IonRouterOutlet>
            {/* Bottom Tabs - Conditionally rendered */}

            {/*//////// ADD BY GOOGLE ///////////*/}
            {/*{(!Capacitor?.isNativePlatform()) ?*/}
            {/*    <div style={{ width: '100%', height: '90px' }}>*/}
            {/*        <ins className="adsbygoogle"*/}
            {/*             style={{ display: 'block' }}*/}
            {/*             data-ad-client="ca-pub-3366036914417048"*/}
            {/*             data-ad-slot="1234567890"*/}
            {/*             data-ad-format="auto"*/}
            {/*             data-full-width-responsive="true"></ins>*/}
            {/*    </div>:''*/}
            {/*}*/}
            {/*//////// ADD BY GOOGLE ///////////*/}

            <IonTabBar
                slot="bottom"
                style={{display: !isMobile ? 'none' : ''}}
                ref={bottomTabSectionRef}
                className={`custom-tabbar main-tab-bar`}
            >
                <IonTabButton tab="home" className={"custom-ripple-color"} onClick={()=>callFunctionToSetCurrentPath('/dashboard/home')} href="/dashboard/home">
                    <IonIcon icon={currentPath === '/dashboard/home' ? home : homeOutline} />
                    <IonLabel>Home</IonLabel>
                </IonTabButton>

                <IonTabButton tab="job" className={"custom-ripple-color"} onClick={()=>callFunctionToSetCurrentPath('/dashboard/job-portal')} href="/dashboard/job-portal">
                    <IonIcon icon={currentPath === '/dashboard/job-portal' ? briefcase : briefcaseOutline} />
                    <IonLabel>Job</IonLabel>
                </IonTabButton>

                <IonTabButton tab="assignments" className={"custom-ripple-color"} onClick={()=>callFunctionToSetCurrentPath('/dashboard/assignments')} href="/dashboard/assignments">
                    <IonIcon icon={currentPath === '/dashboard/assignments' ? clipboard : clipboardOutline} />
                    <IonLabel>Assignments</IonLabel>
                </IonTabButton>

                <IonTabButton tab="more" className={`custom-ripple-color ${(currentPath === '/dashboard/matrimonial' || currentPath === '/dashboard/events' || currentPath === '/dashboard/newsletter' || currentPath === '/dashboard/contribute') ? 'tab-selected' : ''}`} onClick={()=> callFunctionToOpenShowMoreSheet()}>
                    <IonIcon icon={ellipsisHorizontal} />
                    <IonLabel>More</IonLabel>
                    <IonModal
                        isOpen={showMoreSheet}
                        onDidDismiss={() => setShowMoreSheet(false)}
                        breakpoints={[0, 0.2]}
                        initialBreakpoint={0.2}
                        className="more-sheet-modal">
                        <IonContent className="ion-padding">
                            <div className="more-sheet-grid">
                                <div onClick={() => gotToPage('/dashboard/matrimonial', '/dashboard/matrimonial')}
                                     className={`more-sheet-item ${currentPath === '/dashboard/matrimonial' ? 'active' : ''}`}>
                                    <div className="more-tile">
                                        <IonIcon
                                            icon={currentPath === '/dashboard/matrimonial' ? heart : heartOutline}/>
                                    </div>
                                    <span>Matrimonial</span>
                                </div>
                                <div onClick={() => gotToPage('/dashboard/events', '/dashboard/events')}
                                     className={`more-sheet-item ${currentPath === '/dashboard/events' ? 'active' : ''}`}>
                                    <div className="more-tile">
                                        <IonIcon
                                            icon={currentPath === '/dashboard/events' ? calendar : calendarOutline}/>
                                    </div>
                                    <span>Events</span>
                                </div>
                                <div onClick={() => gotToPage('/dashboard/newsletter', '/dashboard/newsletter')}
                                     className={`more-sheet-item ${currentPath === '/dashboard/newsletter' ? 'active' : ''}`}>
                                    <div className="more-tile">
                                        <IonIcon
                                            icon={currentPath === '/dashboard/newsletter' ? newspaper : newspaperOutline}/>
                                    </div>
                                    <span>Newsletter</span>
                                </div>
                                <div onClick={() => gotToPage('/dashboard/contribute', '/dashboard/contribute')}
                                     className={`more-sheet-item ${currentPath === '/dashboard/contribute' ? 'active' : ''}`}>
                                    <div className="more-tile">
                                        <IonIcon
                                            icon={currentPath === '/dashboard/contribute' ? cash : cashOutline}/>
                                    </div>
                                    <span>Contribute</span>
                                </div>
                            </div>
                        </IonContent>
                    </IonModal>
                </IonTabButton>
            </IonTabBar>
        </IonTabs>
    );
};

export default DashboardPage;
